/**
 * The text to show for a failed API call: the translation of the error's
 * stable `code` (apiErrors.<code> in the locales; the response's other
 * fields — min, max… — fill its placeholders), else the server's own
 * message (English), else `fallback` (a translation key) when one is given,
 * else the browser's message (a network error), else "the action failed".
 */
export const errorMessage = (t, error, fallback) => {
  const data = error?.response?.data;
  const body = data && typeof data === 'object' ? data : {};
  if (typeof body.code === 'string' && body.code !== '') {
    const translated = t(`apiErrors.${body.code}`, { ...body, defaultValue: '' });
    if (translated) return translated;
  }
  if (typeof body.error === 'string' && body.error !== '') return body.error;
  if (fallback) return t(fallback);
  return error?.message || t('common.actionFailed');
};

export default errorMessage;
